import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-licenses-card',
  templateUrl: './account-licenses-card.component.html',
  styleUrls: ['./account-licenses-card.component.scss']
})
export class AccountLicensesCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('licenses-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('licenses-counts-spinner');
      this.showCounter = true;
      this.count = this.data.length;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('licenses-counts-spinner');
    }
  }
}
